<tt-page>
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-select ttLabel="carrier" [(ttModel)]="carrierKeyno" [ttData]="carriers" ttDataId="carrier_keyno" ttDataName="carrier_name"></tt-select>
        <tt-select ttLabel="label_type" [(ttModel)]="reportKeyno" [ttData]="reports" ttDataId="reportKeyno" ttDataName="reportId"></tt-select>
        <tt-select ttLabel="printer" [(ttModel)]="printerKeyno" [ttData]="printers" ttDataId="printClientPrinterKeyno" ttDataName="name"></tt-select>
        <tt-input-number ttLabel="quantity" [(ttModel)]="quantity" ttTextAlign="right"></tt-input-number>
        <tt-button ttText="print" [ttLoading]="printing" (ttClick)="printReports()" ttTextAlign="center" ttType="success" ttIcon="fas fa-print"></tt-button>
    </tt-card>
</tt-page>
